var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCharityicon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 18.7871C16.6736 17.0613 15.3032 15.1349 14.0896 13.3359C13.4535 14.3811 12.7824 15.3329 12.0874 16.3931C13.3888 18.2169 14.8999 20.2227 16.3093 21.9981L16.2885 19.2903L18 18.7871Z",
    fill: "#00ADEF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9827 6.95045C15.6351 5.87421 14.0913 4.88709 13.7248 4.83798C13.7005 4.83464 13.6814 4.83531 13.6679 4.84064C13.1258 9.9165 8.73938 15.149 6 18.7346L7.71134 19.2378L7.69094 21.9456C10.5039 17.8417 15.9157 12.2937 15.9827 6.95045Z",
    fill: "#00ADEF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0066 4.35737C13.782 4.35737 15.3667 5.26672 15.9729 6.62941C15.6937 4.01092 14.0438 2 12.0496 2C10.1137 2 8.50254 3.89559 8.15491 6.40207C8.83288 5.16005 10.3414 4.35915 12.0066 4.35737Z",
    fill: "#00ADEF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9343 9.70479C11.2289 8.42388 10.2658 6.45629 10.3558 4.85938C9.33152 5.22849 8.52496 5.91961 8.11193 6.78163C8.00373 8.79877 8.98788 11.4475 10.0414 12.9235C10.7564 11.8962 11.4262 10.7644 11.9343 9.70479Z",
    fill: "#00ADEF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCharityicon);
export default __webpack_public_path__ + "static/media/Charity icon.634e8c11f8bda4399ef41d30a6e18a13.svg";
export { ForwardRef as ReactComponent };